import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // 1. ייבוא
import UserService from '../components/services/user.service.js';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from '../components/ui/use-toast';
import axios from "axios";

export default function UserRegister() {
    const { t, i18n } = useTranslation(); // 2. הפעלת ה-hook
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const checkNickname = async (name) => {
        const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/auth/check-nickname`, { fullName: name });
        return data.exists;
    };

    function isStrongPassword(password) {
        return (
            password.length >= 8 &&
            /[A-Z]/.test(password) &&    // אות גדולה
            /[a-z]/.test(password) &&    // אות קטנה
            /\d/.test(password) &&       // מספר
            /[^A-Za-z0-9]/.test(password) // תו מיוחד
        );
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        // 3. תרגום כל הודעות ה-toast
        if (password !== confirmPassword) {
            toast({
                variant: "destructive",
                title: t('toast.error_title'),
                description: t('toast.passwords_no_match') // מפתח חדש
            });
            return;
        }
        if (!isStrongPassword(password)) {
            toast({
                variant: "destructive",
                title: t('toast.password_not_strong_title'), // מפתח חדש
                description: t('toast.password_not_strong_desc') // מפתח חדש
            });
            return;
        }

        setIsLoading(true);

        let taken = false;
        try {
            taken = await checkNickname(name);
        } catch (e) {
            toast({
                variant: "destructive",
                title: t('toast.error_title'),
                description: t('toast.server_connection_error_desc') // מפתח חדש
            });
            setIsLoading(false);
            return;
        }
        if (taken) {
            toast({
                variant: "destructive",
                title: t('toast.error_title'),
                description: t('toast.nickname_taken_desc') // מפתח חדש
            });
            setIsLoading(false);
            return;
        }

        try {
            // 4. העברת השפה הנוכחית לפונקציית הרישום
            await UserService.register(name, email, password, i18n.language);

            toast({ title: t('toast.register_success_title') }); // מפתח חדש
            window.location.href = '/';
        } catch (error) {
            toast({
                variant: "destructive",
                title: t('toast.register_error_title'), // מפתח חדש
                description: error.message || t('toast.generic_error_desc')
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#f8f5f2] px-4 py-12">
            <div className="max-w-md w-full space-y-8 bg-white p-10 rounded-xl shadow-lg">
                <div>
                    {/* 5. תרגום כל הטקסטים בממשק */}
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-[#232946]">
                        {t('pages.register.title')}
                    </h2>
                </div>
                <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                    <div className="rounded-md shadow-sm -space-y-px">
                        <div>
                            <label htmlFor="full-name" className="sr-only">{t('forms.name_placeholder')}</label>
                            <Input
                                id="full-name"
                                name="name"
                                type="text"
                                autoComplete="name"
                                required
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                onBlur={async (e) => { // תרגום ה-toast גם כאן
                                    if (e.target.value.trim()) {
                                        let taken = false;
                                        try {
                                            taken = await checkNickname(e.target.value);
                                        } catch (e) {
                                            toast({ variant: "destructive", title: t('toast.error_title'), description: t('toast.server_connection_error_desc') });
                                            setIsLoading(false);
                                            return;
                                        }
                                        if (taken) {
                                            toast({ variant: "destructive", title: t('toast.error_title'), description: t('toast.nickname_taken_desc') });
                                        }
                                    }
                                }}
                                className="appearance-none rounded-none relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-[#232946] focus:border-[#232946] focus:z-10 sm:text-sm"
                                placeholder={t('pages.register.nickname_placeholder')}
                            />
                        </div>
                        <div>
                            <label htmlFor="email-address" className="sr-only">{t('forms.email_placeholder')}</label>
                            <Input
                                id="email-address-register"
                                name="email"
                                type="email"
                                autoComplete="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="appearance-none rounded-none relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-[#232946] focus:border-[#232946] focus:z-10 sm:text-sm"
                                placeholder={t('forms.email_placeholder')}
                            />
                        </div>
                        <div>
                            <label htmlFor="password-register" className="sr-only">{t('pages.login.password_placeholder')}</label>
                            <Input
                                id="password-register"
                                name="password"
                                type="password"
                                autoComplete="new-password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="..."
                                placeholder={t('pages.register.password_placeholder')}
                            />
                            <div className="text-xs text-right mb-1 mt-1 text-gray-500">
                                <div className={password.length >= 8 ? 'text-green-600' : 'text-gray-500'}>{t('pages.register.password_strength.length')}</div>
                                <div className={/[A-Z]/.test(password) ? 'text-green-600' : 'text-gray-500'}>{t('pages.register.password_strength.uppercase')}</div>
                                <div className={/[a-z]/.test(password) ? 'text-green-600' : 'text-gray-500'}>{t('pages.register.password_strength.lowercase')}</div>
                                <div className={/\d/.test(password) ? 'text-green-600' : 'text-gray-500'}>{t('pages.register.password_strength.number')}</div>
                                <div className={/[^A-Za-z0-9]/.test(password) ? 'text-green-600' : 'text-gray-500'}>{t('pages.register.password_strength.special')}</div>
                            </div>
                        </div>
                        <div>
                            <label htmlFor="confirm-password" className="sr-only">{t('pages.register.confirm_password_placeholder')}</label>
                            <Input
                                id="confirm-password"
                                name="confirmPassword"
                                type="password"
                                autoComplete="new-password"
                                required
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                className="appearance-none rounded-none relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-[#232946] focus:border-[#232946] focus:z-10 sm:text-sm"
                                placeholder={t('pages.register.confirm_password_placeholder')}
                            />
                        </div>
                    </div>

                    <div>
                        <Button type="submit" disabled={isLoading} className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-[#232946] hover:bg-[#121629] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#232946]"
                        >
                            {isLoading ? t('pages.register.submitting_button') : t('pages.register.submit_button')}
                        </Button>
                    </div>
                </form>
                <div className="text-sm text-center">
                    <span className="text-gray-500">{t('pages.register.have_account')} </span>
                    <Link to="/login" className="font-medium text-[#232946] hover:text-[#121629]">
                        {t('pages.register.login_here')}
                    </Link>
                </div>
            </div>
        </div>
    );
}